<template>
	<div class="field field--text">
		<div class="field__label-wrap">
			<label-field class="field__label" :value="label"></label-field>
			<slot name="post-label"></slot>
		</div>
		<div class="field__element-wrap">
			<input class="field__element" v-bind="$attrs" ref="fieldElement" v-bind:value="value" v-on="inputListeners" />
		</div>
	</div>
</template>

<script>
import LabelField from './LabelField'

export default {
	name: 'TextField',
	inheritAttrs: false,
	components: {
		LabelField
	},
	props: {
		label: String,
		value: [String, Number],
	},
	computed: {
		inputListeners: function ()
		{
			var self = this
			// `Object.assign` merges objects together to form a new object
			return Object.assign({},
				// We add all the listeners from the parent
				this.$listeners,
				// Then we can add custom listeners or override the
				// behavior of some listeners.
				{
					// This ensures that the component works with v-model
					input: function (event) {
						self.$emit('input', event.target.value)
					}
				}
			)
		}
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".field";
	#{$c}
	{
		&--text
		{
			@include media(phab)
			{
				font-size: 16px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/atoms/TextField.vue